export const cacheKey = 'ftu';
export const auto = 'auto';
export const recommended = 'recommended';
export const minimumRecommendedResources = 3;
export const maximumResourcesForShortcut = 5;
